import { useEffect, useState } from 'react';
import { useMutation } from 'react-apollo';
import gql from 'graphql-tag';
import { checkAndUpdateSubscriptionStatus } from '../../graphql/mutations';
import { shouldCheckWithServer, isSubscriptionActive } from '../subscriptionUtils';

export const useSubscriptionCheck = (user, handleUserUpdate) => {
  const [isChecking, setIsChecking] = useState(false);
  
  const [checkSubscription] = useMutation(gql(checkAndUpdateSubscriptionStatus), {
    update(cache, { data: { checkAndUpdateSubscriptionStatus } }) {
      if (checkAndUpdateSubscriptionStatus) {
        console.log("🔍 STEP 15: Subscription status updated from server");
        handleUserUpdate(checkAndUpdateSubscriptionStatus);
      }
    },
  });

  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      if (!user?.subscription) return;
      
      // Check if we need to validate with server
      if (shouldCheckWithServer(user.subscription)) {
        console.log("🔍 STEP 15.1: Subscription needs server validation");
        setIsChecking(true);
        
        try {
          await checkSubscription();
          console.log("🔍 STEP 15.2: Server validation completed");
        } catch (error) {
          console.error("🔍 STEP 15.3: Error checking subscription status:", error);
        } finally {
          setIsChecking(false);
        }
      }
    };

    checkSubscriptionStatus();
  }, [user?.subscription?.nextBillingTime, user?.subscription?.status]);

  return {
    isChecking,
    isActive: isSubscriptionActive(user?.subscription)
  };
}; 